import React, { useCallback } from 'react'
import {
  StyledFormGroup,
  StyledLabel,
  StyledSelect,
  StyledError,
  StyledRequiredAsterisk,
} from './styles/PreSignupForm.style'

interface IPreSignupFormInputs {
  firstName: string
  lastName: string
  phone: string
  cnpj: string
  businessType: string
}

interface SignupSelectInputProps {
  label: string
  name: keyof IPreSignupFormInputs
  value: string
  options: { value: string; label: string }[]
  error?: string
  onChange: (name: keyof IPreSignupFormInputs, value: string) => void
}

export const SignupSelectInput = ({
  label,
  name,
  value,
  options,
  error,
  onChange,
}: SignupSelectInputProps) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(name, event.target.value)
    },
    [name, onChange]
  )

  return (
    <StyledFormGroup>
      <StyledLabel>
        {label} <StyledRequiredAsterisk>*</StyledRequiredAsterisk>
      </StyledLabel>
      <StyledSelect name={name} value={value} onChange={handleChange} requiredEmpty={!!error}>
        <option value="" disabled>
          Selecione seu tipo de negócio
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      {error && <StyledError>{error}</StyledError>}
    </StyledFormGroup>
  )
}
